export default "__VITE_ASSET__D2Pn0dwI__"